import request from '@/utils/consumerRequest';

export function getToken(data) {
  return request({
    url: 'consumer/loginMagicLink',
    method: 'post',
    data,
  });
}
